import { PropsWithChildren } from "react";
import { useAuthorization } from "../hooks/useAuthorization";
import type { Permission } from "../constants/permissions";

type GateProps = {
    anyOf?: Permission[];
    allOf?: Permission[];
    fallback?: any;
};

export default function Gate({ anyOf, allOf, fallback = null, children }: PropsWithChildren<GateProps>) {
    const { can } = useAuthorization();
    const anyOk = !anyOf || anyOf.some((p) => can(p));
    const allOk = !allOf || allOf.every((p) => can(p));
    if (!anyOk || !allOk) return fallback;
    return <>{children}</>;
}
